import React, { useEffect } from 'react'
import Grid from '@mui/material/Grid'
import CardContent from '@mui/material/CardContent'
import Button from '@mui/material/Button'
import CircularProgress from '@mui/material/CircularProgress'
import {
    getGetIdsUsersCurrentQueryKey,
    useGetIdsConfig,
    usePutIdsUsersUserIdValidateCgu,
} from '@toktokdoctech/tokapi-client'
import makeStyles from '@mui/styles/makeStyles'
import CardMedia from '@mui/material/CardMedia'
import FormControlLabel from '@mui/material/FormControlLabel'
import Checkbox from '@mui/material/Checkbox'
import { useNavigate } from 'react-router-dom'
import { displaySnackbar } from '../../actions/main'
import ContentPage from '../Common/ContentPage'
import styles from './styles/cguStyles'
import useCurrentUser from '../../hooks/useCurrentUser'
import { useAppDispatch } from '../../store'
import { tanstackQueryClient } from '../../api/tanstackClient'

// @ts-expect-error TS(2345) FIXME: Argument of type '(theme: any) => { pdf: { marginT... Remove this comment to see the full error message
const useStyles = makeStyles(styles)

function Cgu() {
    const { hasAgreedLatestCGUs, id } = useCurrentUser()

    const [hasChecked, setHasChecked] = React.useState(false)
    const [isSaving, setIsSaving] = React.useState(false)
    const classes = useStyles()
    const dispatch = useAppDispatch()
    const navigate = useNavigate()

    const { mutateAsync } = usePutIdsUsersUserIdValidateCgu()

    const { data: config, isFetching } = useGetIdsConfig()

    /**
     * accept CGU
     * redirect to main page
     */
    const acceptCgu = async () => {
        if (!config) {
            throw new Error('acceptCgu should not be callable if the global config is not available.')
        }

        setIsSaving(true)

        try {
            await mutateAsync({ userId: id, data: { version: config.currentCGUIdsVersion } })

            const currentUserKey = getGetIdsUsersCurrentQueryKey()
            tanstackQueryClient.invalidateQueries({ queryKey: currentUserKey })
            navigate('/')
            dispatch(
                displaySnackbar(
                    'success',
                    'Votre modification a bien été enregistrée !',
                    undefined,
                    `[CGU] validation CGU`,
                ),
            )
        } catch (error) {
            dispatch(
                displaySnackbar(
                    'error',
                    'Erreur lors de la modification !',
                    undefined,
                    `[CGU] erreur lors de la validation CGU error: ${error.message}`,
                ),
            )
        }

        setIsSaving(false)
    }

    const isLoading = isSaving || isFetching

    return (
        <ContentPage
            title={"Conditions générales d'utilisation du service TokTokDoc"}
            subtitle={
                "Nous avons mis à jour nos Conditions Générales d'Utilisation (CGU), nous vous serions reconnaissants de bien vouloir en prendre connaissance afin de continuer à utiliser le service TokTokDoc."
            }
        >
            <CardContent>
                <Grid container direction="column" alignItems="center" justifyContent="center" spacing={2}>
                    <Grid item xs={12}>
                        <FormControlLabel
                            control={
                                <Checkbox checked={hasChecked || hasAgreedLatestCGUs} disabled={hasAgreedLatestCGUs} />
                            }
                            onChange={() => {
                                setHasChecked(!hasChecked)
                            }}
                            data-cy="CGUAgree"
                            label="J’ai lu et accepte les Conditions générales d’utilisation du service TokTokDoc"
                        />
                    </Grid>
                    <Grid item xs={12} sm={6} md={2}>
                        <div className={classes.buttonHolder}>
                            {isLoading && <CircularProgress size={24} className={classes.buttonProgress} />}
                            <Button
                                variant="contained"
                                color="primary"
                                disabled={!hasChecked || isLoading}
                                onClick={acceptCgu}
                                data-cy="agree"
                            >
                                ACCEPTER
                            </Button>
                        </div>
                    </Grid>
                </Grid>
            </CardContent>
            <Grid container direction="column" alignItems="center" justifyContent="center">
                <CardMedia
                    className={classes.media}
                    component="iframe"
                    image={`${window._env_.REACT_APP_HDS_HOST}/static/file/cgu/CGU_Effecteur.pdf`}
                />
            </Grid>
        </ContentPage>
    )
}

export default Cgu
